import Container from "@/components/common/Container";
import Modal from "@/components/common/Modal";
import Dropdown from "@/components/contact-us/DropDown";
import Layout from "@/components/layout/Layout";
import axios from "axios";
import { API_URL, emailValidationRegex } from "const/common";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";

const CHOOSE_SERVICE = [
  "Staff Augmentation",
  "Custom Web & App Development",
  "Data Scraping",
  "On-Demand Solution",
  "Digital Transformation",
  "Cloud Engineering & DevOps",
];
const PROJECT_BUDGET = [
  "Less than $10K",
  "$10K to $25K",
  "$25K to $40K",
  "$40K to $50K",
  "$50K & Above",
];
function ContactUsPage() {
  const [disabled, setDisabled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [phoneValue, setPhoneValue] = useState("");
  const [selectedService, setSelectedService] = useState("");
  const [selectedBudget, setSelectedBudget] = useState("");
  const router = useRouter();
  useEffect(() => {
    window.addEventListener("load", function () {
      document.querySelector("#name").focus();
    });
  }, []);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm();
  const onSubmit = async (values) => {
    const { name, lastName, email, message, service, budget } = values;
    const formattedMessage = message?.toString().replace(/\r?\n/g, "<br />");
    if (Object.keys(errors).length === 0) {
      setDisabled(true);
      axios
        .post(`${API_URL}admin/contactusdata`, {
          name,
          email,
          lastName,
          dataService: service,
          projectBudget: budget,
          phone: phoneValue,
          message: formattedMessage,
          enquiryPage: router.asPath,
        })
        .then(() => {
          setPhoneValue("");
          reset();
          router.push("/thankyou");
        })
        .finally(() => {
          setDisabled(false);
        });
    }
  };
  const handleSelect = (option) => {
    setSelectedService(option);
  };
  const handleBudgetSelect = (option) => {
    setSelectedBudget(option);
  };
  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <Layout
      description="Have questions in mind? - Shoot your requirements here and we will be there with our technology experts who can deal with every problem."
      title="Contact Us - Solutions for your Every Queries | ultroNeous"
    >
      <div className="bg-header-background bg-bottom-center bg-cover bg-no-repeat py-40  md:pt-44 xl:pt-40 md:pb-72">
        <p className="text-2xl text-primary-yellow font-medium text-center leading-loose">
          <span>Contact Us</span>
        </p>
        <h1 className="text-white text-center text-4xl md:text-6xl font-normal lg:pb-8">
          <span>Get in touch today!</span>
        </h1>
      </div>
      <Container large className="bg-primary-black">
        <div className="relative">
          <div className="bg-[#f2f2f2] mx-auto rounded-2xl py-10 px-4 md:py-9 md:pl-5 md:pr-9 absolute -top-28 md:-top-64 grid xl:grid-cols-2 gap-9 w-full">
            <div className="bg-[url(/assets/contact-us/contact-us-bg.webp)] bg-center bg-cover bg-no-repeat rounded-2xl flex-col justify-end items-start hidden xl:flex">
              <div className="pl-12">
                <Link href="skype:live:.cid.bad0265d8d280477?chat">
                  <a className="flex justify-start items-center text-black mb-6">
                    <Image
                      alt="skype"
                      height={19}
                      quality={100}
                      src="/assets/contact-us/skype.webp"
                      width={19}
                    />
                    <span className="text-base md:text-sm lg:text-xl font-medium ml-4 text-white">
                      ultroNeous technologies
                    </span>
                  </a>
                </Link>
                <Link href="mailto:hello@ultroneous.com">
                  <a className="flex justify-start items-center text-black mb-6">
                    <Image
                      alt="mail"
                      height={15}
                      layout="fixed"
                      quality={100}
                      src="/assets/contact-us/email.webp"
                      width={19}
                    />
                    <span className="text-base md:text-sm lg:text-xl font-medium ml-4 text-white">
                      hello@ultroneous.com
                    </span>
                  </a>
                </Link>
                <Link href="tel:+91-78748-13131">
                  <a className="flex justify-start items-center text-black mb-5">
                    <Image
                      alt="indiaflag"
                      height={19}
                      quality={100}
                      src="/assets/contact-us/phone.webp"
                      width={19}
                      layout="fixed"
                    />
                    <span className="text-base md:text-sm lg:text-xl font-medium ml-4 text-white">
                      +91-78748-13131
                    </span>
                  </a>
                </Link>
              </div>
            </div>
            <div className="md:pt-4 xl:pb-20">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="flex flex-col md:flex-row md:gap-7">
                  <div className="w-full">
                    <input
                      id="name"
                      {...register("name", { required: true })}
                      autoComplete="off"
                      placeholder="Full Name*"
                      className="rounded-lg text-sm md:text-base p-3.5 md:py-4 md:px-5 w-full border border-solid border-transparent focus:border focus:border-solid focus:border-primary-yellow focus-visible:outline-none bg-white"
                    />
                    <p className="m-0 ml-2 text-red-600">
                      <span>
                        {errors.name ? "Name is required" : <>&nbsp;</>}
                      </span>
                    </p>
                  </div>
                  <div className="w-full">
                    <input
                      autoComplete="off"
                      type="text"
                      {...register("lastName", { required: true })}
                      className="rounded-lg text-sm md:text-base p-3.5 md:py-4 md:px-5 border border-solid border-transparent w-full focus:border focus:border-solid focus:border-primary-yellow focus-visible:outline-none bg-white"
                      placeholder="Last name*"
                    />
                    <p className="m-0 ml-2 text-red-600">
                      <span>
                        {errors.lastName ? "Name is required" : <>&nbsp;</>}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row md:gap-7 pt-1 md:pt-0">
                  <div className="w-full">
                    <input
                      autoComplete="off"
                      type="text"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: emailValidationRegex,
                          message: "Enter valid email",
                        },
                      })}
                      className="rounded-lg text-sm md:text-base p-3.5 md:py-4 md:px-5 w-full border border-solid border-transparent focus:border focus:border-solid focus:border-primary-yellow focus-visible:outline-none bg-white"
                      placeholder="Email ID*"
                    />
                    <p className="m-0 ml-2 text-red-600">
                      <span>
                        {errors?.email?.message ? (
                          errors?.email?.message
                        ) : (
                          <>&nbsp;</>
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="w-full contact-us mb-4 md:mb-0">
                    <PhoneInput
                      country="us"
                      enableSearch={true}
                      value={phoneValue}
                      onChange={(value) => {
                        setPhoneValue(value);
                        setValue("contact", value);
                      }}
                    />
                  </div>
                </div>
                <div className="flex flex-col md:flex-row md:gap-7 pt-1 md:pt-0">
                  <div className="w-full">
                    <Dropdown
                      name={"service"}
                      control={control}
                      placeholder="Choose Service"
                      options={CHOOSE_SERVICE}
                      onSelect={handleSelect}
                      selectedOption={selectedService}
                    />
                    <p className="m-0 ml-2 text-red-600">
                      <span>
                        {errors.service ? (
                          "This field is required."
                        ) : (
                          <>&nbsp;</>
                        )}
                      </span>
                    </p>
                  </div>
                  <div className="w-full">
                    <Dropdown
                      name={"budget"}
                      control={control}
                      placeholder="Project Budget"
                      options={PROJECT_BUDGET}
                      onSelect={handleBudgetSelect}
                      selectedOption={selectedBudget}
                    />
                    <p className="m-0 ml-2 text-red-600">
                      <span>
                        {errors.budget ? (
                          "This field is required."
                        ) : (
                          <>&nbsp;</>
                        )}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="pb-10 md:pb-8">
                  <textarea
                    {...register("message", { required: true })}
                    className="resize-none rounded-lg text-sm md:text-base py-4 px-6 border border-solid border-transparent w-full focus:border focus:border-solid focus:border-primary-yellow focus-visible:outline-none bg-white"
                    placeholder="Would you like to explain about your project?"
                    rows={4}
                  />
                  <p className="m-0 ml-2 text-red-600">
                    <span>
                      {errors.message ? "Message is required." : <>&nbsp;</>}
                    </span>
                  </p>
                </div>
                <div className="text-center md:text-start">
                  <button
                    className="py-4 px-10 bg-primary-yellow text-lg font-semibold text-white rounded-lg"
                    type="submit"
                    disabled={disabled}
                  >
                    Inquire Now
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="pt-[50rem] md:pt-[32rem]"></div>
          <div className="bg-[#251D1E] py-10 md:py-20 px-4 md:px-24 grid xl:grid-cols-2 gap-y-10 xl:gap-0 rounded-lg">
            <div>
              <p className="text-3xl md:text-4xl font-medium leading-normal md:leading-snug text-white">
                Our team is here to simplify your business journey.
              </p>
            </div>
            <div className="flex justify-start xl:justify-end items-center">
              <button
                onClick={openModal}
                className="font-semibold text-base md:text-lg text-white bg-primary-yellow py-4 px-10 rounded-lg"
              >
                Schedule 30 min call
              </button>
            </div>
          </div>
          <div className="pt-20 md:pt-40 px-4 md:px-24 pb-12 md:pb-24">
            <h2 className="text-3xl md:text-6xl font-medium text-center text-white pb-7 md:pb-24">
              <span>We are located in</span>
            </h2>
            <div className="grid xl:grid-cols-2 gap-10 md:gap-20">
              <div className="py-3 px-11 md:py-10 md:px-14 border border-solid border-primary-yellow text-center rounded-2xl">
                <div className="fs-0 w-24 h-16 md:w-fit md:h-fit mx-auto">
                  <Image
                    src={"/assets/contact-us/office-india.webp"}
                    width={193}
                    height={125}
                    alt="office-india"
                  />
                </div>
                <h3 className="text-xl md:text-3xl font-bold text-center py-5 md:pb-7 text-white">
                  <span>INDIA</span>
                </h3>
                <p className="text-xs leading-relaxed md:text-xl font-medium md:leading-relaxed text-white/50 max-w-56 md:max-w-100 mx-auto">
                  <span>
                    B/ 401-402, Shilp Corporate Park, Rajpath Rangoli Rd,
                    Thaltej, Ahmedabad, Gujarat 380054
                  </span>
                </p>
              </div>
              <div className="py-3 px-11 md:py-10 md:px-14 border border-solid border-primary-yellow text-center rounded-2xl">
                <div className="fs-0 w-24 h-16 md:w-fit md:h-fit mx-auto">
                  <Image
                    src={"/assets/contact-us/office-canada.webp"}
                    width={193}
                    height={125}
                    alt="office-india"
                  />
                </div>
                <h3 className="text-xl md:text-3xl font-bold text-center py-5 md:pb-7 text-white">
                  <span>CANADA</span>
                </h3>
                <p className="text-xs leading-relaxed md:text-xl font-medium md:leading-relaxed text-white/50 max-w-28 md:max-w-52 mx-auto">
                  <span>1932 50 Ave SW, Calgary, AB T2T 2W2 Canada</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Modal isOpen={modalOpen} onClose={closeModal} />
    </Layout>
  );
}

export default ContactUsPage;
